import UtilitiesService from '@/services/UtilitiesService'
import keycloak from "@/utils/keycloak";
const utilitiesService = UtilitiesService.build()

export function guardLogin(to, from, next) {
  utilitiesService.search().then(data => {
    localStorage.setItem('configurations', JSON.stringify(data))
    next({name: 'dashboardRoute'})
    return
  }).catch(() => {
    keycloak.logout()
  })
}
